import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminEmailTemplates = lazy(() => import("@/pages/admin/AdminEmailTemplates"));

export const Route = createFileRoute("/admin/mailmallar")({
  component: () => <AdminEmailTemplates />,
});
